// Manager approvals (discount > limit, cancelling fired items) are decided by the server; the UI only reacts to its 403.
const approvalKind = (err) => {
  const d = String(err?.response?.data?.detail || '');
  if (err?.response?.status === 400 && /removing items from a saved order requires a reason/i.test(d)) return 'remove';
  if (err?.response?.status !== 403 || !/manager approval/i.test(d)) return null;
  return /kitchen/i.test(d) ? 'cancel' : 'discount';
};

// `ask` opens the masked ManagerApprovalDialog and resolves {pin, reason} | null.
// Returns null → not an approval error; {} → cashier aborted; otherwise the fields to resend.
export async function promptApproval(err, already = {}, ask) {
  const kind = approvalKind(err);
  if (!kind || (kind === 'discount' ? already.discount_manager_pin : kind === 'cancel' ? already.cancel_manager_pin : already.cancel_reason)) return null;
  const res = await ask({
    title: { cancel: 'Cancel kitchen items', remove: 'Remove items', discount: 'Discount approval' }[kind],
    detail: err.response.data.detail, needReason: kind !== 'discount', noPin: kind === 'remove',
  });
  if (!res) return {};
  if (kind === 'discount') return { ...already, discount_manager_pin: res.pin };
  if (kind === 'remove') return { ...already, cancel_reason: res.reason };
  return { ...already, cancel_manager_pin: res.pin, cancel_reason: res.reason };
}
